import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import PropTypes from "prop-types";
import { ClassificationIcon } from "../../../components";

const YaraHistoryItem = ({ selectedRuleId, item, onClick }) => (
  <Row className="o-rs-overlay-history__item">
    <Col
      xs={8}
      className={`o-rs-overlay-history__time ${
        selectedRuleId === item.value ? "history-selected" : ""
      }`}
    >
      {item.text}
    </Col>
    <Col
      className={`${selectedRuleId === item.value ? "history-selected" : ""}`}
    >
      <span className="threat-inline width-25-pc">
        <ClassificationIcon classification="malicious" />
        {item.malicious}
      </span>
      <span className="threat-inline width-25-pc">
        <ClassificationIcon classification="suspicious" />
        {item.suspicious}
      </span>
      <span className="threat-inline width-25-pc">
        <ClassificationIcon classification="goodware" />
        {item.goodware}
      </span>
      <span className="threat-inline width-25-pc">
        <ClassificationIcon classification="unknown" />
        {item.unknown}
      </span>
    </Col>
    <Col xs={1} className="c-sample-counts__status">
      <a style={{ cursor: "pointer" }} onClick={() => onClick(item.value)}>
        Load
      </a>
    </Col>
  </Row>
);
YaraHistoryItem.propTypes = {
  selectedRuleId: PropTypes.number,
  onClick: PropTypes.func,
  item: PropTypes.shape({
    goodware: PropTypes.string,
    malicious: PropTypes.string,
    retrohunt_finish_time: PropTypes.string,
    retrohunt_start_time: PropTypes.string,
    retrohunt_status: PropTypes.number,
    suspicious: PropTypes.string,
    text: PropTypes.string,
    timestamp: PropTypes.string,
    unknown: PropTypes.string,
    value: PropTypes.number
  }).isRequired
};
export default YaraHistoryItem;
